import React from "react";
import { Reveal } from "@/components/motion/Reveal";
import { Button, Eyebrow } from "@/components/ui-kit";
import { IMG } from "@/data/content";
import { unsplashSrc } from "@/lib/img";

export function CTASection({
  eyebrow = "Start a conversation",
  title = "Let's talk about what your portfolio needs.",
  body = "Every engagement starts with a conversation. Tell us what's driving the initiative and we'll tell you straight whether we're the right fit.",
  image = IMG.loungeWood,
}) {
  return (
    <section className="relative overflow-hidden bg-charcoal text-paper">
      {image && (
        <div className="absolute inset-0">
          <img src={unsplashSrc(image, 1200, 55)} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-charcoal/70" />
        </div>
      )}
      <div className="relative mx-auto max-w-8xl px-6 py-24 lg:px-10 lg:py-32">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-8">
            <Reveal>
              <Eyebrow dark>{eyebrow}</Eyebrow>
              <h2 className="mt-6 max-w-3xl text-4xl font-normal leading-[1.1] tracking-tightish sm:text-5xl lg:text-6xl">
                {title}
              </h2>
              <p className="mt-6 max-w-xl text-base leading-[1.8] text-paper/70">{body}</p>
            </Reveal>
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <Reveal delay={0.15}>
              <Button to="/contact" variant="light" track="primary" data-testid="cta-contact-btn">
                Discuss an Initiative
              </Button>
              <a
                href="mailto:brandon@pmnetwork.org"
                className="mt-4 block text-sm text-paper/60 link-underline lg:inline-block"
                data-testid="cta-email-link"
              >
                brandon@pmnetwork.org
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
